import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profit',
  templateUrl: './profit.component.html',
  styleUrls: ['./profit.component.scss']
})
export class ProfitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
